var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.878,
    height: 17.369,
    viewBox: "0 0 14.878 17.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3625",
    "data-name": "Tracciato 3625",
    d: "M111.866,720.369h-8.854A1.947,1.947,0,0,1,101,718.495V706.874A1.947,1.947,0,0,1,103.012,705h5.367l5.5,5.122v8.373A1.947,1.947,0,0,1,111.866,720.369Z",
    transform: "translate(-100 -704)",
    fill: "none",
    stroke: "#101103",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.46a9f5b4e703ab2665f4fc94c73ceb96.svg";
export { ForwardRef as ReactComponent };